import css from './image.module.css'

import type { ImageBorderRadius, ImageObjectFit } from './image.types.ts'

type ResolvedAspectRatio =
  | '1/1'
  | '4/3'
  | '3/2'
  | '16/9'
  | '3/4'
  | '2/3'
  | '9/16'

export const styles = {
  base: css.image,
  dynamic: (
    aspectRatio: ResolvedAspectRatio,
    objectFit: ImageObjectFit,
    radius: ImageBorderRadius,
  ) => ({
    aspectRatio: aspectRatio.replace('/', ' / '),
    objectFit,
    // The tokens are declared on `.image`, the class of the element this
    // inline style lands on, so they resolve although the servicing PostCSS
    // strips the theme's :root tokens.
    borderRadius: radius === 'none' ? '0px' : `var(--border-radius-${radius})`,
  }),
}
